/**
 * Paths that must work without a Supabase session.
 * Keep in sync with route-registry publicAccess routes and legacy public surfaces.
 */

import { isAnalyzerPage } from '@/message-analyzer/lib/analyzer-utils'
import { isLensTokenAccessPath } from '@/lib/lens/utils'
import { getRouteForPath } from './route-registry'

/** True when the path is intentionally reachable without logging in. */
export function isPublicAppPath(pathname: string): boolean {
  if (pathname.startsWith('/auth')) return true
  if (pathname.startsWith('/demo')) return true
  // Soft redirect target — must stay public so guests can hit /explore and land on /analyze
  if (pathname === '/explore' || pathname.startsWith('/explore/')) return true
  if (isAnalyzerPage(pathname)) return true
  if (pathname === '/extension-auth') return true
  if (pathname === '/extension-success') return true
  if (pathname === '/extension/install') return true
  if (isLensTokenAccessPath(pathname)) return true

  const route = getRouteForPath(pathname)
  if (route?.publicAccess) return true

  return false
}
